import emailjs from '@emailjs/browser';
import type { ContactFormData } from '@/types';

// EmailJS Configuration
// Estas claves se deben configurar en EmailJS Dashboard
const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';

/**
 * Initialize EmailJS with public key
 */
export const initEmailJS = () => {
  emailjs.init(EMAILJS_PUBLIC_KEY);
};

/**
 * Send contact form data via EmailJS
 * @param formData - Contact form data
 * @param recaptchaToken - reCAPTCHA verification token
 * @returns Promise that resolves when email is sent
 */
export const sendContactEmail = async (
  formData: ContactFormData,
  recaptchaToken: string
): Promise<void> => {
  try {
    // Prepare template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      message: formData.message,
      to_email: 'contacto@liec.com.mx',
      reply_to: formData.email,
      recaptcha_token: recaptchaToken,
      // Additional metadata
      submission_date: new Date().toLocaleString('es-MX', {
        timeZone: 'America/Mexico_City',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    };

    // Send email using EmailJS
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );

    if (response.status !== 200) {
      throw new Error('Failed to send email');
    }

    // Email sent successfully - no need to log sensitive data
  } catch (error) {
    console.error('Error sending email:', error instanceof Error ? error.message : 'Unknown error');
    throw new Error('No se pudo enviar el mensaje. Por favor, intenta nuevamente.');
  }
};

/**
 * Validate EmailJS configuration
 * @returns true if configuration is valid
 */
export const isEmailJSConfigured = (): boolean => {
  return (
    EMAILJS_SERVICE_ID !== 'YOUR_SERVICE_ID' &&
    EMAILJS_TEMPLATE_ID !== 'YOUR_TEMPLATE_ID' &&
    EMAILJS_PUBLIC_KEY !== 'YOUR_PUBLIC_KEY'
  );
};
